import ChargeRfidListView from '../../components/ChargeRfidListView';

ChargeRfidListScreen.propTypes = {};

function ChargeRfidListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <ChargeRfidListView />
    </div>
  );
}

export default ChargeRfidListScreen;
